import { linkToHome } from "$routes/_lib/links";
import { TelephoneRequestModal } from "$routes/_lib/telephone-request-modal/telephone-request-modal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ConsentModal } from "./_internal/consent-modal";

const ModalSequence = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);

  return (
    <>
      <TelephoneRequestModal
        open={step === 0}
        onCompleted={() => setStep(1)}
        onSkip={() => setStep(1)}
        isInOnboardingFlow={true}
      />
      <ConsentModal
        open={step === 1}
        onCompleted={() => navigate(linkToHome())}
      />
    </>
  );
};

export const FirstSignInPage = () => {
  return <ModalSequence />;
};
